const PREPARE_NEXT_ACTION_CODES = {
    PAY: 'pay',
    REDIRECT: 'redirect',
    CHOOSE_PAYMENT_GROUP: 'choose_payment_group',
    CREATE_BINDING: 'create_binding',
};
const COMMIT_NEXT_ACTION_CODES = {
    THREE_DS_REQUIRED: '3ds_required',
};

export { COMMIT_NEXT_ACTION_CODES, PREPARE_NEXT_ACTION_CODES };
//# sourceMappingURL=nextActionCodes.js.map
